// @flow
import React, { Component } from 'react'
import { translations, translateFunc } from '../../shared/localize'

type Props = {|
  minValuableAmount: number,
  weekAmount: number,
  monthAmount: number,
  showValues: boolean,
  hint: string,
  onRecommendation?: (number) => void
|}

type State = {| value: string |}

const t = translateFunc(translations.replenishment.recommendations)

export default class Recommendations extends Component<Props, State> {
  state = { value: '' }

  render() {
    const { weekAmount, monthAmount, minValuableAmount, showValues, hint } = this.props

    let weekShown = weekAmount > minValuableAmount
    let monthShown = monthAmount > minValuableAmount

    return (
      <div>
        <div className="balance-b__hint">{hint}</div>
        {showValues && (weekShown || monthShown) && (
          <div className="replenishment-recommendation">
            <div className="replenishment-recommendation__header">{t('header')}</div>
            <table className="replenishment-recommendation__table">
              <tbody>
                {weekShown && this.renderRow(t('week'), weekAmount)}
                {monthShown && this.renderRow(t('month'), monthAmount)}
              </tbody>
            </table>
          </div>
        )}
      </div>
    )
  }

  renderRow(article: string, amount: number) {
    return (
      <tr className="replenishment-recommendation__table-row">
        <td className="replenishment-recommendation__table-cell">{article}</td>
        <td className="replenishment-recommendation__table-cell">
          {amount} {t('currency')}
        </td>
        <td className="replenishment-recommendation__table-cell">
          <a
            className="replenishment-recommendation__link"
            href="#"
            onClick={(e) => this.clicked(e, amount)}
          >
            {t('replenish')}
          </a>
        </td>
      </tr>
    )
  }

  clicked(e: any, amount: number) {
    e.preventDefault()
    this.props.onRecommendation && this.props.onRecommendation(amount)
  }
}
